<template>
	<div>
		<h3>Welcome to my projects. Please select a project above to continue.</h3>
	</div>
</template>